module.exports = __webpack_public_path__ + "img/social-media.72aa4de8.svg";